import React from 'react'
import { Button, Space } from 'antd'
import { QRCode } from 'react-qrcode-logo'
import styled from 'styled-components'
import { DownloadOutlined } from '@ant-design/icons'
import Logo from '../../assets/img/thaiqrcodelogo.png'
import Border from '../../assets/img/thaiqrcodeborder.jpeg'
import { PaymentConfig } from 'Store/pos/types'
import { getCorporateQrValue, getIndividualQrValue } from 'helpers/qrpayment'
import { MyTheme } from 'Components/common/Theme'
import { Theme } from 'Components/common'

type Props = {
  width?: number
  merchantName?: string
} & PaymentConfig

const ThaiQRPayment = (props: Props) => {
  const {
    width = 200,
    payment_type,
    bill_payment_id = '',
    ref_1,
    ref_2,
    personal_id = '',
    account_name = '',
    merchantName = '',
  } = props
  let qrCodeVal = ''
  if (payment_type === 'individual') {
    qrCodeVal = getIndividualQrValue(personal_id)
  }
  if (payment_type === 'coporate') {
    qrCodeVal = getCorporateQrValue(bill_payment_id, ref_1, ref_2)
  }

  console.log('qrCodeVal', qrCodeVal)

  const downloadQR = () => {
    // const canvas = document.getElementById('react-qrcode-logo') as HTMLCanvasElement
    // const img = canvas && canvas.toDataURL('image/png')
    // const link = document.createElement('a')
    // link.download = `ThaiQRPayment.png`
    // link.href = img
    // link.click()
    const layout = document.getElementById('demo') as HTMLCanvasElement
    const base_image = new Image()
    base_image.src = Border
    const qr = document.getElementById('react-qrcode-logo') as HTMLCanvasElement
    const qrImg = qr
    const ctx = layout && (layout.getContext('2d') as CanvasRenderingContext2D)
    const width = 550
    const height = 689
    ctx.drawImage(base_image, 0, 0, width, height)
    const qrSize = 300
    const left = (550 - qrSize) / 2
    const qrTop = 220
    ctx.drawImage(qrImg, left, qrTop, qrSize, qrSize)

    ctx.font = `25px ${Theme.fontFamily.medium}`
    ctx.textAlign = 'center'
    const textNameTop = qrSize + qrTop + 40
    ctx.fillText(`${merchantName}`, width / 2, textNameTop)

    ctx.font = `20px ${Theme.fontFamily.primary}`
    ctx.textAlign = 'center'
    const textTop = textNameTop + 30
    ctx.fillText(`บัญชี: ${account_name}`, width / 2, textTop)

    const canvas = document.getElementById('demo') as HTMLCanvasElement
    const anchor = document.createElement('a')
    anchor.download = `ThaiQRPayment_${merchantName}.png`
    anchor.href = canvas && canvas.toDataURL('image/png')
    anchor.click()
  }

  return (
    <QrWrapper>
      <HiddenQr className="qr-download">
        <canvas id="demo" width="550" height="689"></canvas>
        <QrBorder id="qr-download">
          <BG>
            <img src={Border} width={'100%'} id="qr-border" />
            <QrCodeWrapper>
              <QRCode
                size={500}
                value={qrCodeVal}
                logoImage={Logo}
                logoHeight={500 * 0.23}
                logoWidth={500 * 0.4}
                ecLevel="H"
              />
              <Name>{merchantName}</Name>
              <Account>บัญชี: {account_name}</Account>
            </QrCodeWrapper>
          </BG>
        </QrBorder>
      </HiddenQr>
      <Space direction="vertical" align="center">
        <QrBorder>
          <BG>
            <img src={Border} width={'100%'} />
            <QrCodeWrapper>
              <QRCode
                size={width}
                value={qrCodeVal}
                logoImage={Logo}
                logoHeight={width * 0.23}
                logoWidth={width * 0.4}
                ecLevel="M"
              />
              <Name>{merchantName}</Name>
              <Account>บัญชี: {account_name}</Account>
            </QrCodeWrapper>
          </BG>
        </QrBorder>
        <DownloadTxt>
          <Button type="link" onClick={downloadQR} icon={<DownloadOutlined />} size={'large'}>
            ดาวน์โหลด QR Payment
          </Button>
        </DownloadTxt>
      </Space>
    </QrWrapper>
  )
}

const QrWrapper = styled.div``

const QrBorder = styled.div`
  width: 400px;
  max-width: 100%;
  min-width: 230px;
  float: left;
  position: relative;
  min-height: 1px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: center;

  img {
    max-width: 100%;
  }
}
`

const BG = styled.div`
  display: inline-block;
  position: relative;
`

const QrCodeWrapper = styled.div`
  position: absolute;
  top: 75%;
  left: 50%;
  transform: translate(-50%, -75%);
  color: white;
  padding: 4px;
  font-size: 17px;
  line-height: 18px;
`

const HiddenQr = styled.div`
  display: none;
`

const DownloadTxt = styled.div`
  margin-left: 10px;
  .ant-btn {
    font-size: 12px;
  }
`

const Name = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h5};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-top: 10px;
`

const Account = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-top: 10px;
`

export default ThaiQRPayment
